import { css } from "styled-components"
import { colors } from "../../helpers/colors"
import { BreakPoints, media } from "../../helpers/rwd"

export const HeaderWrapperStyles = css`
  &.default {
    min-height: 564px;
  }
  &.gradient {
    position: relative;
    background-color: ${colors.dark};
    padding-top: 116px;
    padding-bottom: 120px;
    height: 969px;
    margin-top: -60px;
    margin-bottom: -404px;
    &:after {
      display: block;
      content: "";
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        ${colors.dark} 100%
      );
    }
    & > div {
      z-index: 1;
    }
  }
`

export const VideoBackgroundStyles = css``

export const ContentWrapperStyles = css`
  position: relative;
`

export const ContentStyles = css`
  margin-left: 30px;
  margin-right: 30px;
  max-width: 600px;
  min-height: 330px;
  h1 {
    margin: 0;
    line-height: 1.2em;
  }
  ${media.max(BreakPoints.desktop)} {
    margin-bottom: 40px;
  }
  ${media.max(BreakPoints.tablet)} {
    margin-left: 0;
    margin-right: 0;
  }
`
export const DescriptionStyles = css``
export const ButtonWrapperStyles = css``
